import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import useAuth from '../../hooks/useAuth'
import { paths } from '../../utils/paths'
import { goToHome } from '../../utils/routeActions'

export default function HomeRedirector(): JSX.Element {
  const { authInformation, logout } = useAuth()
  const navigate = useNavigate()
  const [params] = useSearchParams()

  useEffect(() => {
    if (!authInformation) {
      logout?.()
      navigate(paths.loginWithPin)
    }
    if (authInformation?.impersonatorJurisdictionId && authInformation?.impersonatorId) {
      navigate(paths.businessAssetsFiling)
      return
    } else {
      goToHome(navigate, params.get('redirectToFiling') === 'true')
    }
  }, [authInformation, navigate, logout, params])

  return <Loader loading={true} />
}
